export enum NotificationsConfig {
  MaximumNotifications = 50,
  MaxDurationInSeconds = 120,
  PollingDurationInSeconds = 5
}

export const openLogsModal = "openLogsModal";
export const lastRunEntryId = "lastRunEntryId";
